import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "LEARN_AGE_GRADE",
  title: defineMessage({
    id: "fig.learning.LEARN_AGE_GRADE.title",
    defaultMessage: `Learning outcomes by age and grade`,
  }),
  caption: defineMessage({
    id: "fig.learning.LEARN_AGE_GRADE.caption",
    defaultMessage: `Average learning outcomes are even worse when children out of school are taken into account.`,
  }),
  source: defineMessage({
    id: "fig.learning.LEARN_AGE_GRADE.source",
    defaultMessage: `ASER Pakistan`,
  }),
};
